import type * as React from "react"
import logo from "@/assets/logo.png"
import { cn } from "@/lib/utils"

interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  title?: string
  showMenuIcon?: boolean
  onMenuClick?: () => void
  drawerContent?: React.ReactNode
}

export function Header({
  title = "ロゴ",
  showMenuIcon = true,
  onMenuClick,
  drawerContent,
  className,
  ...props
}: HeaderProps) {
  return (
    <header
      className={cn(
        "fixed z-10 top-0 left-0 w-full bg-slate-50 border-b border-slate-200",
        className
      )}
      {...props}
    >
      {/* Header Content */}
      <div className="relative h-[60px] w-full bg-slate-50 flex items-center justify-center px-4">
        {/* Logo */}
        <img src={logo} alt="AGENTCALL エージェントコール" className="h-10 w-auto" />
      </div>
    </header>
  )
}

export const HeaderVariants = {
  Header,
}
